import jwtDecode from 'jwt-decode'

function JwtManager (alg) {
  this.algorithm = alg || 'HS256'

  this.supportedAlgs = {
    'HS256': ['hash_hmac', 'SHA256'],
    'HS512': ['hash_hmac', 'SHA512'],
    'HS384': ['hash_hmac', 'SHA384'],
    'RS256': ['openssl', 'SHA256']
  }
}

JwtManager.prototype.isValid = function (rawToken) {
  try {
    this.decode(rawToken)
  } catch (error) {
    return false
  }

  return true
}

JwtManager.prototype.decode = function (rawToken) {
  let tokenHeader = jwtDecode(rawToken, { header: true })
  let tokenBody = jwtDecode(rawToken)

  this.checkValid(tokenHeader, tokenBody)

  return tokenBody
}

JwtManager.prototype.checkValid = function (tokenHeader, tokenBody) {
  if (typeof tokenHeader.alg === 'undefined' || tokenHeader.alg.length === 0) {
    throw new jwtDecode.InvalidTokenError('Empty Algorithm')
  } else if (this.supportedAlgs[tokenHeader.alg].length === 0) {
    throw new jwtDecode.InvalidTokenError('Algorithm Not Supported')
  } else if (this.algorithm !== tokenHeader.alg) {
    throw new jwtDecode.InvalidTokenError('Algorithm Not Allowed')
  }

  // Cannot Validate Token Currently Against Signature

  let currentTime = Math.round(Date.now() / 1000)

  if (typeof tokenBody.nbf !== 'undefined' && tokenBody.nbf > currentTime) {
    throw new jwtDecode.InvalidTokenError('Not Yet Valid')
  } else if (typeof tokenBody.iat !== 'undefined' && tokenBody.iat > currentTime) {
    throw new jwtDecode.InvalidTokenError('Invalid Token')
  } else if (typeof tokenBody.exp !== 'undefined' && tokenBody.exp < currentTime) {
    throw new jwtDecode.InvalidTokenError('Expired Token')
  }
}

const jwtManager = new JwtManager()

export default jwtManager
